import {Directive, ElementRef, Input, Renderer2, OnInit} from '@angular/core';
import {PrincipalService} from './principal.service';

@Directive({
  selector: '[hasAnyAuthority]'
})
export class HasAnyAuthorityDirective implements OnInit {

  @Input() hasAnyAuthority:string;
  authority:string[];

  constructor(private principal:PrincipalService, private el:ElementRef, private renderer:Renderer2) {
  }

  ngOnInit() {
    this.authority = this.hasAnyAuthority.replace(/\s+/g, '').split(',');
    if (this.authority.length > 0) {
      this.setVisibilitySync();
    }
    this.principal.getAuthenticationState().subscribe(identity => this.setVisibilitySync());
  }

  private setVisible() {
    this.renderer.removeClass(this.el.nativeElement, 'hidden');
  }

  private setHidden() {
    this.renderer.addClass(this.el.nativeElement, 'hidden');
  }

  private setVisibilitySync() {

    let result = this.principal.hasAnyAuthority(this.authority);
    if (result) {
      this.setVisible();
    } else {
      this.setHidden();
    }
  }
}
